import { Mutations, Actions } from './types'

export default {
  [Actions.STORE_RECIPES](context, recipes) {
    context.commit(Mutations.STORE_RECIPES, recipes)
  }
}
